export const UPDATE_COLLAPSED_INFO = 'UPDATE_COLLAPSED_INFO';

export function updateCollapsedInfo(collapsedInfo) {
  return {
    type: UPDATE_COLLAPSED_INFO,
    data: collapsedInfo,
  };
}
